import React, { Component } from 'react'
import {View, StyleSheet,Text} from 'react-native'
import {JDRouter} from '@jdreact/jdreact-core-lib'
import PropTypes from 'prop-types'

const {NavigationBar} = JDRouter;

class PageContainer extends Component {
	static propTypes = {
		renderOverlay: PropTypes.func
	};
	render() {
		return (
				<View style={styles.wrapper}>
					<NavigationBar Title={this.props.title} RightButton={this.props.shareButton} showMoreNav={true}/>
					<View style={[styles.body, this.props.bodyStyle]}>
						{ this.props.children }
					</View>
					{this._renderOverlay()}
				</View>
		);
	}

	_renderOverlay = () => {
		if (typeof this.props.renderOverlay === 'function') {
			return this.props.renderOverlay();
		}
		return null;
	};
}

const styles = StyleSheet.create({
	wrapper: {
		flex: 1,
		backgroundColor: '#F3F4F7'
	},
	body: {
		flex: 1,
	},
});

export default PageContainer;
